/*------------------------------------*\
 $GLOBAL VARIABLES
 \*------------------------------------*/
var $html = jQuery('html'),
  $body = jQuery('body'),
  $win = jQuery(window),
  $doc = jQuery(document),
  $t = jQuery(this);

var is_phone,
  touch,
  ltie9,
  lteie9,
  wh, ww,
  dh, ar,
  ieMobile,
  ua = navigator.userAgent;

var is_webkit = ua.match(/webkit/i);
var is_firefox = ua.match(/gecko/i);
var is_newer_ie = ua.match(/msie (9|([1-9][0-9]))/i);
var is_older_ie = ua.match(/msie/i) && !is_newer_ie;
var is_ancient_ie = ua.match(/msie 6/i);
var is_mobile = ua.match(/mobile/i);
var is_OSX = (ua.match(/(iPad|iPhone|iPod|Macintosh)/g) ? true : false);
var is_android = ((ua.indexOf('Mozilla/5.0') > -1 && ua.indexOf('Android ') > -1 && ua.indexOf('AppleWebKit') > -1) && !(ua.indexOf('Chrome') > -1));


/**
 * This is useful if you want to review all notices in the console.
 *
 * Set it to true if you want debug the code!
 */
var debug = true;

/*------------------------------------*\
 $SENSIBLE DEFAULTS
 \*------------------------------------*/
(function ($, window, undefined) {

  /**
   *  DETECT VIEWPORT SIZE
   */
  function browserSize() {
    wh = $win.height();
    ww = $win.width();
    dh = $doc.height();
    ar = ww / wh;
  }


  /**
   *  DETECT PLATFORM
   */
  function platformDetect() {

    $.support.touch = 'ontouchend' in document;

    var navUA = navigator.userAgent.toLowerCase(),
      navPlat = navigator.platform.toLowerCase();

    var is_iPhone = navPlat.indexOf('iphone'),
      is_iPod = navPlat.indexOf('ipod'),
      is_AndroidPhone = navPlat.indexOf('android'),
      is_safari = (navUA.indexOf('safari') != -1 && navUA.indexOf('chrome') == -1) ? true : false,
      svgSupport = (window.SVGAngle) ? true : false,
      svgSupportAlt = (document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1')) ? true : false;

    is_phone = (is_iPhone > -1 || is_iPod > -1 || is_AndroidPhone > -1) ? true : false;
    touch = $.support.touch ? true : false;
    ltie9 = $.support.leadingWhitespace ? false : true;
    lteie9 = typeof window.atob === 'undefined' ? true : false;

    ieMobile = navigator.userAgent.match(/Windows Phone/i) ? true : false;

    if (touch || ieMobile) {
      $html.addClass('touch');
    }

    if (is_safari) $body.addClass('safari');
    if (is_phone) $body.addClass('phone');

  }

});


/*------------------------------------*\
 $APP.JS
 \*------------------------------------*/
jQuery(document).ready(function ($) {
  "use strict";

  /**
   * $LAZY LOADING INIT
   *
   * When an image finished loaded add class to parent for
   * the image to fade in
   */
  function lazyLoad() {

    var $images = $('.lazy-load');

    $images.each(function () {

      var $img = $t,
        src = $img.attr('data-src');

      $img.on('load', function () {
        $img.closest('.mosaic__item').addClass('is-loaded');
      });

      $img.attr('src', src);

    });
  };

  /**
   * $ON WINDOW LOAD
   *
   * When an image finished loaded add class to parent for
   * the image to fade in
   */
  $win.load(function () {
    if (debug) {
      console.group('OnWindowLoad');
    }

    lazyLoad();

    if (debug) {
      console.groupEnd();
    }
  });

  /* ----------------------------------------------------------------------------------------------------------
   05 IsoTope
   -------------------------------------------------------------------------------------------------------- */
  var $container = jQuery('.content-inner');
  $container.imagesLoaded(function () {
    $container.isotope({
      filter: '*',
      layoutMode: 'fitRows',
      animationEngine: 'best-available',
      animationOptions: {
        duration: 750,
        easing: 'easeOutExpo',
        queue: false
      }
    });
  });

  jQuery('.w-filters-item').each(function () {
    var item = jQuery(this),
      link = item.find('.w-filters-item-link');

    link.click(function () {
      if (!item.hasClass('active')) {
        jQuery('.w-filters-item').removeClass('active');

        item.addClass('active');

        $('.filter-list-btn').html($(this).html());
        $('.filter-list').slideToggle('fast');

        var selector = jQuery(this).attr('data-filter');

        $container.isotope({
          filter: selector,
          animationOptions: {
            duration: 750,
            easing: 'easeOutExpo',
            queue: false,
          }
        });
        return false;
      }
    });
  });

  /**
   * $SLICK SLIDER
   */
  function initialiseSliders() {

    //Main slider
    $('.main-slider').slick({
      autoplay: true,
      arrows: false,
      fade: true
    });

  }

  initialiseSliders();

  /**
   * Set active menu item
   */
  function setActvieMenuItem() {
    //$('.current-menu-item').append("<span class='triangle'></span>");

    var menuItem = $('.menu-item');

    menuItem.each(function () {

      if ($(this).hasClass('current-menu-item')) {

        $(this).append("<span class='triangle active'></span>");


      } else {

        $(this).append("<span class='triangle'></span>");

      }

    });

  }

  setActvieMenuItem();

  $('.searchform-btn').click(function () {
    var forminput = $('.searchform-input');
    var from = $('.searchform');

    forminput.toggleClass('show-input');

    if (forminput.hasClass('show-input')) {

      from.css('z-index', '10');

    } else {

      from.css('z-index', '-1');

    }

  });

  $('.filter-list-btn').click(function () {
    $('.filter-list').slideToggle('fast');

    if ($('.w-callout-content').is(":visible")) {

      $('.w-callout-content').slideToggle('fast');

    }

  });

  $('.mobile-nav-btn').click(function () {
    $('nav').fadeToggle();
  });

  //if ( $('.sidebar').find('.contnet').text() == '' ) {
  //	$('.sidebar').remove();
  //}

  //$('.callout-btn').click(function () {
  //
  //	var calloutContent = $('.w-callout-content');
  //	var homeUrl = window.location.protocol + "//" + window.location.host + "/" + "fbi/alibox/";
  //
  //	if ( calloutContent.is(":visible") ) {
  //
  //		$(this).find('img').attr('src', homeUrl + 'wp-content/themes/alibox/public/img/calculate-btn.png');
  //		$(this).find('img').removeClass('set-margin');
  //
  //	} else {
  //
  //		$('html, body').animate({
  //			scrollTop: $('.callout-btn').offset().top - 20
  //		}, 'fast');
  //
  //		$(this).find('img').attr('src', homeUrl + 'wp-content/themes/alibox/public/img/calculate-btn-active.png');
  //		$(this).find('img').addClass('set-margin');
  //
  //	}
  //
  //	calloutContent.slideToggle('fast');
  //
  //});

  //$('.slide-tap').click(function () {
  //
  //	var btn = $(this).text();
  //	var register = 'http://alibox.net/registreren.php';
  //	var login = 'http://alibox.net/fbi_login.php';
  //	var frame = $('.frame');
  //
  //	$('.slide-tap').removeClass('active');
  //	$(this).addClass('active');
  //
  //	if ( btn == 'Registreren' ) {
  //
  //		frame.fadeOut(400,function(){
  //			frame.attr('src',register );
  //			frame.fadeIn(400);
  //		});
  //
  //	} else {
  //
  //		frame.fadeOut(400,function(){
  //			frame.attr('src',login );
  //			frame.fadeIn(400);
  //		});
  //
  //	}
  //
  //});

  /**
   * Fade out overlay google maps
   */
  $('.overlay').click(function () {
    $(this).fadeOut();
  });

  $('.scroll-top-btn').click(function () {
    $('body').animate({ scrollTop: "0" });
  });

  $(window).scroll(function () {
    var scrolled = $(document).scrollTop();
    var btn = $('.scroll-top-btn');

    if (scrolled >= 350) {

      btn.addClass('slideIn');

    } else {

      btn.removeClass('slideIn');

    }
  });

  /*
   * get mobile menu title
   */
  function getPageTitle() {

    var navigation = $('#navigation').find('ul');
    var menuItem;
    var breadcrumb = $('.w-breadcrumbs');
    var pageTitle = breadcrumb.find('.current').text();
    var menuText;

    navigation.children().each(function () {

      menuItem = $(this).text();

      if (menuItem == pageTitle) {

        menuText = menuItem;

      }

    });

    if (menuText == undefined) {

      menuText = 'Menu';

    }

    return menuText;

  }

  /*
  * Animate logo part on home page
  */
  if ($('body').hasClass('home')) {

    $('.typist').typist({
      speed: 16,
      text: '...zelf alimentatie berekenen!',
      cursor: false
    });

  } else {

    $('.typist').html('...zelf alimentatie berekenen!');

  }

  /*
   * create / delete newsletter box
   */
  $('.newsletter').click(function () {

    $('.newsletter-from').fadeToggle('fast');

  });

  $('.close-form').click(function () {
    $('.newsletter-from').fadeToggle('fast');
  });

  /*
   * hide prev/next button in side bar
   */
  if (!$body.hasClass('single-fbi_news')) {
    $('.prev-next-btns').hide();
  }


});

